module.exports = __webpack_public_path__ + "static/TBT-bb3a6638783712c97b1b78b4af5a69fa.jpg";